export enum ContactPreferenceType {
    Email = 20,
    Phone = 21,
    NotifyMe = 22,
    MyRetailSiteEmail = 23,
    MyretailSitePhone = 24
}
